import type {Feature} from 'ol';
import type {TourMeta} from '../../apis/api-tours.js';
import {computeTourMeta} from './tracktime.ts';

export function computeTourFacts(
  coordsXyzm: Array<[number, number, number, number]>,
  bikespeed: number,
  hikespeed: number,
  winterhikespeed: number,
  snowshoespeed: number,
  mountainbikespeed: number,
): TourMeta {
  const meta = computeTourMeta(
    coordsXyzm,
    bikespeed,
    hikespeed,
    winterhikespeed,
    snowshoespeed,
    mountainbikespeed,
  );
  return meta;
}

export function aggregateFacts(segments: readonly Feature[]): TourMeta {
  if (!segments.length) {
    return null;
  }
  const meta: TourMeta = {
    elemin: Number.MAX_SAFE_INTEGER,
    elemax: Number.MIN_SAFE_INTEGER,
    length: 0,
    totalup: 0,
    totaldown: 0,
    biking: 0,
    walking: 0,
    snowshoeTrekking: 0,
    winterHiking: 0,
    mountainBiking: 0,
  };

  segments.forEach((segment) => {
    const segmentMeta = segment.get('facts');
    meta.elemin = Math.min(meta.elemin, segmentMeta.elemin);
    meta.elemax = Math.max(meta.elemax, segmentMeta.elemax);
    meta.length += segmentMeta.length;
    meta.totalup += segmentMeta.totalup;
    meta.totaldown += segmentMeta.totaldown;
    meta.biking += segmentMeta.biking;
    meta.walking += segmentMeta.walking;
    meta.snowshoeTrekking += segmentMeta.snowshoeTrekking;
    meta.winterHiking += segmentMeta.winterHiking;
    meta.mountainBiking += segmentMeta.mountainBiking;
  });
  return meta;
}
